import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);
class ImageParallax {
    constructor() {
        gsap.utils.toArray(".image-parallax").forEach(function(container) {
            let image = container.querySelector("img");
            let tl = gsap.timeline({
                scrollTrigger: {
                    trigger: container,
                    scrub: true,
                    pin: false,
                    //markers:true
                },
            }); 
            tl.from(image, {
                yPercent: -30,
                ease: "none",
            }).to(image, {
                yPercent: 30,
                ease: "none",
            }); 
        });
    }
}
export default ImageParallax